import { Tabs as TabsPrimitive } from "@base-ui/react/tabs";
import { cn } from "../lib/cn";
import { focusHaloFlush, panelMotion } from "../lib/motion";

function Tabs({ className, ...props }: TabsPrimitive.Root.Props) {
  return (
    <TabsPrimitive.Root data-slot="tabs" className={cn("flex flex-col", className)} {...props} />
  );
}

/** A row of choices on one quiet ground, the chosen one a shade firmer. */
function TabsList({ className, ...props }: TabsPrimitive.List.Props) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn(
        "inline-flex w-fit items-center gap-0.5 rounded-full bg-foreground/5 p-1",
        className,
      )}
      {...props}
    />
  );
}

function TabsTab({ className, ...props }: TabsPrimitive.Tab.Props) {
  return (
    <TabsPrimitive.Tab
      data-slot="tabs-tab"
      className={cn(
        "h-7 rounded-full px-3 text-sm font-medium text-muted-foreground hover:text-foreground data-active:bg-foreground/10 data-active:text-foreground",
        panelMotion,
        focusHaloFlush,
        className,
      )}
      {...props}
    />
  );
}

function TabsPanel({ className, ...props }: TabsPrimitive.Panel.Props) {
  return (
    <TabsPrimitive.Panel
      data-slot="tabs-panel"
      className={cn("outline-none", focusHaloFlush, className)}
      {...props}
    />
  );
}

export { Tabs, TabsList, TabsPanel, TabsTab };
